import { GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL, LIST_PARENT_SESSION_PROMPTS_TOOL } from './tool-names.js';

export function isForkSessionMcpToolName(name: string): boolean {
  return name === LIST_PARENT_SESSION_PROMPTS_TOOL || name === GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL;
}
